import React from 'react'
import { TextLg } from './text'

export const Logo = ({ className="", style={}, ...rest }) => {
  return (
    <button
      className={`
        michroma-regular font-extrabold h-full items-center
        flex gap-1 text-white select-none cursor-pointer
        ${className}
      `}
      style={style}
      { ...rest }
    >
      <span>Code</span>
      <span>-</span>
      <span className='text-blue-600'>Connect</span>
    </button>
  )
}
